import { useEffect } from 'react';

import type { TeamsClientUser as User } from '@atlaskit/teams-client/user';

import { useUser } from '../../main';

export const useTeamsUser = (
	userId: string,
	skip?: boolean,
): {
	data: User | undefined;
	isLoading: boolean;
	error: Error | undefined;
	refetch: () => Promise<void>;
	setUserData: (data: Partial<User>) => void;
	updateUserInfo: (
		userId: string,
		fieldKey:
			| 'title'
			| 'location'
			| 'locale'
			| 'email'
			| 'fullName'
			| 'nickname'
			| 'department'
			| 'companyName'
			| 'phoneNumber'
			| 'aboutMe',
		value: string,
	) => Promise<void>;
} => {
	const [users, { getUser, setUserData, ...rest }] = useUser();
	const userState = users[userId];

	useEffect(() => {
		if (!skip) {
			getUser(userId);
		}
	}, [getUser, skip, userId]);

	return {
		...rest,
		data: userState?.user,
		isLoading: userState?.isLoading,
		error: userState?.error,
		refetch: (): Promise<void> => getUser(userId, true),
		setUserData: (data: Partial<User>): void => setUserData(userId, data),
	};
};
